var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgSantander = _a => {
  var _b;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#EA1D25"
  }), React.createElement("path", {
    d: "M20.3831 14.7864C20.3374 14.0964 20.1548 13.4064 19.7895 12.8083L16.6846 7.33406C16.4563 6.92004 16.2736 6.46002 16.1823 6L16.0453 6.23001C15.2691 7.56407 15.2691 9.26616 16.0453 10.6002L18.5567 14.9704C19.3329 16.3045 19.3329 18.0066 18.5567 19.3406L18.4197 19.5706C18.3284 19.1106 18.1457 18.6506 17.9174 18.2366L15.6344 14.2344L14.1732 11.6583C13.9449 11.2442 13.7623 10.7842 13.671 10.3242L13.534 10.5542C12.7578 11.8883 12.7578 13.5444 13.534 14.9244V14.9244L16.0453 19.2946C16.8216 20.6287 16.8216 22.3308 16.0453 23.6648L15.9083 23.8949C15.817 23.4348 15.6344 22.9748 15.4061 22.5608L12.2555 17.0865C11.8446 16.3505 11.6619 15.5225 11.6619 14.6944C8.32869 15.5685 6 17.4545 6 19.6166C6 22.6528 10.4747 25.0909 15.9997 25.0909C21.5246 25.0909 25.9993 22.6528 25.9993 19.6166C26.045 17.5466 23.762 15.6605 20.3831 14.7864Z",
    fill: "white"
  }));
};
export default SvgSantander;